<template>
  <div class="share-dialog">
    <button @click="$emit('close')">&times;</button>
    <button @click="shareFacebook">facebook</button>

    <button>
      <a class="button" :href="emailShareLink" @click="trackEmailShare">e-post</a>
    </button>

    <button class="copy-link" @click="copyLink">kopeeri link</button>
  </div>
</template>

<script>
/**
 * Resources for sharing on desktop
 * https://www.devils-heaven.com/facebook-javascript-sdk-photo-upload-from-canvas/
 *
 * http://twitter.com/share?text=Merry%20xmas%20from%20Tank&url=https://xmas.tank.ee/&hashtags=tank
 *
 * https://www.linkedin.com/shareArticle?mini=true&url=https://xmas.tank.ee/
 */
export default {
  name: 'share-dialog',
  data() {
    const url = new URL(location.pathname, location.href).href // location.href.split('?')[0]
    const emailSubject = encodeURIComponent('Kõik on fotograafi süü, ausalt!')
    const emailBody = encodeURIComponent(`Ära karda, sellel lingil on vaid minu jõulukaart, mitte viirus. Kuigi viirus oleks ehk isegi parem variant…

${url}?utm_source=Newsletter&utm_medium=Jaga&utm_campaign=Tank_Xmas_2019&utm_content=E-post

Proovi sinagi, nii et seda nägu!`)

    return {
      url,
      // emailShareLink: `mailto:tuttav@example.com?subject=${emailSubject}&body=${emailBody}`
      emailShareLink: `mailto:?subject=${emailSubject}&body=${emailBody}`
    }
  },
  props: {
    cardUrl: String
  },
  methods: {
    shareFacebook() {
      window.gtag('event', 'fb-share-opened')
      this.openShareWindow(
        `https://www.facebook.com/sharer/sharer.php?u=${this.url}&quote=Vaheta+nii,+et+seda+nägu!+Tanki+jõulukaardigeneraator+huugab+täiel+piinlikkusel+–+proovi+sinagi!`
      )
    },
    shareTwitter() {
      this.openShareWindow(
        `http://twitter.com/share?text=Merry%20xmas%20from%20Tank&url=${this.url}&hashtags=tank,christmas`
      )
    },
    openShareWindow(url) {
      const childWindow = window.open(url, 'pop', 'width=600, height=400, scrollbars=no')
      const checkChild = () => {
        if (childWindow.closed) {
          clearInterval(timer)
          this.$emit('action')
        }
      }
      const timer = setInterval(checkChild, 500)
    },
    copyLink() {
      const _input =
        document.getElementById('_input') ||
        (input => {
          input.id = '_input'
          input.style.position = 'fixed'
          input.style.left = '-9999px'
          return input
        })(document.body.appendChild(document.createElement('input')))

      _input.value = unescape(
        this.url + `?utm_source=Newsletter&utm_medium=Jaga&utm_campaign=Tank_Xmas_2019&utm_content=Kopeeri-link`
      )
      _input.select()
      document.execCommand('copy')
      window.getSelection().removeAllRanges()
      window.gtag('event', 'link-copied')
      this.$emit('action')
    },
    trackEmailShare() {
      this.$emit('action')
      window.gtag('event', 'email-share-opened')
    }
  }
}
</script>

<style lang="scss">
.share-dialog {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95%;
  max-width: 500px;

  display: flex;
  flex-direction: column;
  text-align: center;

  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  z-index: 1;
  padding: 20px;
  background-color: var(--background);

  .share-button,
  .copy-link {
    padding-left: 30px;
    padding-right: 30px;
  }
  .dialog-title {
    display: flex;
    justify-content: space-between;
  }
  .dialog-title .button {
    margin-top: 0;
  }
  .share-button,
  .share-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .share-dialog.is-open {
    display: block;
    z-index: 2;
  }

  header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .close-button {
    background-color: transparent;
    border: none;
    padding: 0;
  }

  .close-button svg {
    margin-right: 0;
  }

  button,
  .button {
    margin: 0;
    text-align: center;
    justify-content: center;
    font-size: 2.6rem;
    padding: 0;
  }
  & > button:first-child {
    font-size: 3.4rem;
    margin-bottom: 1rem;
  }

  .link {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-top: 1rem;
    border-radius: 4px;
    background-color: #eee;
  }
  .copy-link {
    margin-top: 1rem;
  }

  .pen-url {
    margin-right: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
